import React from 'react';
import '../styles/captcha.css'
import {api} from "../api/v1/api";
import Alert from "@material-ui/lab/Alert"

export default class Sps2InfoCaptcha extends React.Component{
    CaptchaRef;
    serviceApi = null;


    state = {
        CaptchaImage: null,
        CaptchaIdentifier: null,
        validated: false,
        attempts: 0,
        captchaInstruction: "Please enter the text displayed",
        isIncorrectCaptcha: null,
    }
    constructor(props) {
        super(props);
        this.serviceApi = new api();
        this.CaptchaRef = React.createRef();
        this.captchaIdHandler = this.captchaIdHandler.bind(this)
        this.captchaImageHandler = this.captchaImageHandler.bind(this)
        this.getCaptchaData = this.getCaptchaData.bind(this)
        this.resetCaptcha = this.resetCaptcha.bind(this)
    }

    componentDidMount() {
        this.getCaptchaData().then()
    }

    async getCaptchaData(){
        await this.props.presenterHandler()
        await this.serviceApi.getCaptchaIdentifier(this.captchaIdHandler, this.captchaImageHandler)
    }

    async resetCaptcha(isError){
        if(await document.getElementById("captcha") !== null){
            if(await document.getElementById("captcha").classList !== null){
                await document.getElementById("captcha").classList.remove("InvalidCaptcha")
            }
        }
        await this.props.presenterHandler()
        await this.serviceApi.getCaptchaIdentifier(this.captchaIdHandler, this.captchaImageHandler)
        await document.getElementById("captcha").classList.add("InvalidCaptcha")
        await this.setState({
            isIncorrectCaptcha: isError
        })
    }

    async captchaIdHandler(cId){
        await this.setState({
            CaptchaIdentifier: cId
        })
    }

    async captchaImageHandler(image){
        let myBlob = await new Blob([image], {type: 'image/jpeg'})
        await this.setState({
            CaptchaImage: URL.createObjectURL(image)
        })
    }

    timeout(delay){
        return new Promise(res => setTimeout(res, delay));
    }
    async onClickSubmit(){
        let captchaText = await document.getElementById("captchaInput").value
        await this.serviceApi.validateCaptcha(this.state.CaptchaIdentifier, captchaText,
            this.props.validationHandler, this.resetCaptcha, this.props.callBackFunction).then(()=>{
                document.getElementById("captchaInput").value = ""
        })
    }
    async onClickRefresh(){
        await this.serviceApi.getCaptchaIdentifier(this.captchaIdHandler, this.captchaImageHandler)
    }

    render(){
        return(
            <div>
                <div className={"tds-captcha"} id={"captcha"}>
                    <div className={"gmst-captcha-image-container"}>
                        {this.state.CaptchaImage !== null ?(
                            <img src = {this.state.CaptchaImage} alt={""}/>
                        ):(<React.Fragment/>)}
                    </div>
                    <div className={"input-container"}>
                        <label>{this.captchaInstruction}</label>
                        <input type="text" id="captchaInput" maxLength="6" name="captcha" autoComplete={"off"}/>
                    </div>
                    <div className={"buttons-container"}>
                        <button className="captcha-submit" type="button" value="Submit" onClick={()=>this.onClickSubmit()}>
                            Submit</button>
                        <button className="gmst-captcha-refresh" type="button" value="Refresh" onClick={()=>this.onClickRefresh()}>
                            Refresh
                        </button>
                    </div>
                </div>
                {this.state.isIncorrectCaptcha ? (
                    <Alert className={"incorrectCaptchaMessage"} severity={"error"}>
                        Incorrect captcha. Please try again
                    </Alert>
                ):(<React.Fragment/>)}
            </div>
        )
    }
}
